import React from 'react'
import { useTranslation } from 'react-i18next'
import { LOAD_MORE_LIMIT } from 'utils/__consts/Common/Global'
import Loading from '../Loaders/Loading'
import SvgIcon from '../Icons/SvgIcon'

interface Props {
  isLoading: boolean
  itemsCount: number
  hasNextPage: boolean
  onNextPage: () => void
}

const LoadMore: React.FC<Props> = ({
  isLoading,
  itemsCount,
  hasNextPage,
  onNextPage,
}: Props) => {
  const { t } = useTranslation()

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  return (
    <div className="load-more">
      {itemsCount > LOAD_MORE_LIMIT && (
        <button
          type="button"
          className="go-top-button"
          disabled={isLoading}
          onClick={goTop}
        >
          <SvgIcon name="expand-less" />
        </button>
      )}
      {hasNextPage && (
        <button
          type="button"
          className="load-more-button"
          disabled={isLoading}
          onClick={onNextPage}
        >
          <Loading isLoading={isLoading} isCommon>
            <span className="label">{t('generic.button.loadMore')}</span>
            <SvgIcon name="expand-more" />
          </Loading>
        </button>
      )}
    </div>
  )
}

export default LoadMore
